// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/pricing.scss
// module id = 7
// module chunks = 0